import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {NzModalService} from 'ng-zorro-antd/modal';
import {AddDescriptionComponent} from '../../shared/add-description/add-description.component';
import {DestinationDTO} from '../../../../core/dto/destination';
import {FormBuilder, FormControl} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DestinationService} from '../../../../core/services/destination.service';
import {LoadingService} from '../../../../core/services/loading.service';
import * as _ from 'lodash';
import {NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs} from 'ng-zorro-antd/upload';
import {UploadService} from '../../../../core/services/upload.service';
import {ActionAlert} from '../../../../core/dto/actionAlert';
import {NzMessageService} from 'ng-zorro-antd/message';
import {GooglePlacesService} from "../../../../core/services/google-places.service";
import {SettingService} from "../../../../core/services/setting.service";
import {LanguageService} from "../../../../core/services/language.service";
import {AuthService} from "../../../../modules/auth/services/auth.service";
import {SETTINGS} from "../../../../core/config/common.settings";
import { getSubstringAfterLastComma } from "../../../../core/ult-functions/text";
import {AppUtils} from "../../../../core/config/app.utils";
import {CountryService} from "../../../../core/services/country.service";
import {UserService} from "../../../../core/services/user.service";

const getBase64 = (file: File): Promise<string | ArrayBuffer | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

@Component({
  selector: 'app-mc-destination',
  templateUrl: './mc-destination.component.html',
  styleUrls: ['./mc-destination.component.scss'],
})
export class McDestinationComponent implements OnInit {
  rId: any = undefined;
  onEdit = false;
  formErrors: any;
  destinationDTO = new DestinationDTO();
  pageType: string | any;
  destinationName = '';
  descriptions: any[] = [];

  fileList: NzUploadFile[] = [];
  previewImage: string | undefined = '';
  previewVisible = false;
  actionMessage = new ActionAlert();
  placeholderPath: any = '../assets/img/placeholder-image.png';
  searchName = "";
  nearestLocation = "";
  googleSuggestions: any = [];
  googlePlaceDetails: any;
  isDetailsExist = false;
  isLocationExist = false;
  destination: any;
  contexts: any[] = [];

  language: any = 'en';
  languageType: any;
  languageField = new FormControl();
  selectedLanguages: any = [];
  languages: any = [];
  title = '';
  listOfOption: any = [];
  listOfNearestOption: any = [];
  selectedImage: any = '';
  userPreferredImage: string = '';
  isDisplayMap = false;
  @ViewChild("popConfirm", { static: false, read: ElementRef }) popConfirm?: ElementRef;
  protected readonly SETTINGS = SETTINGS;

  countries: any[] = [];
  selectedCountry = "";

  constructor(
    private nzModalService: NzModalService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private destinationService: DestinationService,
    private loadingService: LoadingService,
    private uploadService: UploadService,
    private msg: NzMessageService,
    private googlePlacesService: GooglePlacesService,
    private settingService: SettingService,
    private languageService: LanguageService,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
    private countryService: CountryService,
    private translocoService: TranslocoService,
  ) {
  }

  ngOnInit(): void {
    this.loadingService.start();
    this.alertMessageInfo();
    this.getCountries().then();
    this.getLanguages().then();
    this.findBrand().then((data: any) => {
      this.addMissingTitles(this.destinationDTO.city, this.destinationDTO.country, data);
    });

    this.destinationService.onDestinationChange.next({});
    this.destinationService.onDestinationChange.subscribe(async (destination) => {
      if (!_.isEmpty(destination)) {
        this.destinationDTO = new DestinationDTO(destination);
        this.pageType = 'edit';
        try {
          const pref = await this.userService.getContentImagePreference('destinations', this.destinationDTO._id);
          this.userPreferredImage = pref?.imageUrl || this.destinationDTO.defaultImage || '';
        } catch {
          this.userPreferredImage = this.destinationDTO.defaultImage || '';
        }
        this.fileList = this.destinationDTO.images.map(
          (image: any, index: number) => ({
            uid: (index + 1).toString(),
            name: 'image.png',
            status: 'done',
            url: image,
          })
        );

        if (this.destinationDTO.entryType === this.SETTINGS.ENTRY_TYPES.MANUAL) {
          this.isDisplayMap = true;
          this.isLocationExist = true;
        }
      } else {
        this.pageType = 'new';
        this.destinationDTO = new DestinationDTO();
      }
      if (this.pageType === 'edit') {
        this.destinationName = this.destinationDTO.entryType === this.SETTINGS.ENTRY_TYPES.GOOGLE ? this.destinationDTO.city + ", " + this.destinationDTO.country : this.destinationDTO.city;
        this.filterContentByLanguage(this.language);
      }
    });
    this.rId = this.route.snapshot.paramMap.get('id');
    this.destinationService.getOneDestination(this.rId).then(() => {
      this.loadingService.stop();
    });

    this.languageField.valueChanges.subscribe((lang: any) => {
      if (this.pageType === 'edit') {
        this.filterContentByLanguage(lang);
        this.languageType = this.languages?.find((l: any) => l.code === lang);
      }
    });
  }

  async getCountries(): Promise<void> {
    this.countries = await this.countryService.getCountries();
  }

  addEditDescription(description: any, keyword: any, contentType: string, queryData: any, descriptionType: any): void {
    this.nzModalService
      .create({
        nzTitle: description
          ? this.translocoService.translate('destinations.descriptionModal.editTitle')
          : this.translocoService.translate('destinations.descriptionModal.addTitle'),
        nzContent: AddDescriptionComponent,
        nzFooter: null,
        nzComponentParams: {
          description,
          keyword,
          contentType,
          queryData,
          descriptionType
        },
      })
      .afterClose.subscribe(data => {
      if (data) {
        if (!this.contexts) {
          this.msg.error(
            this.translocoService.translate('destinations.descriptionModal.missingNameError')
          );
        } else {
          const descriptionIndex = this.destinationDTO.contexts.findIndex(
            (context) => context.body === description || context.keyword === keyword
          );
          this.submit({...data, language: this.language}, descriptionIndex);
        }
      }
    });
  }

  handlePreview = async (file: NzUploadFile | any): Promise<void> => {
    if (!file.url && !file.preview) {
      // tslint:disable-next-line:no-non-null-assertion
      file.preview = await getBase64(file.originFileObj!);
    }
    this.previewImage = file.url || file.preview;
    this.previewVisible = true;
  }

  async submit(payload: any, descriptionIndex: number): Promise<any> {
    this.onEdit = true;
    this.loadingService.start();
    let changeablePayload = _.cloneDeep(payload);
    if (descriptionIndex > -1) {
      this.destinationDTO.contexts[descriptionIndex] =
        payload;
    } else {
      this.destinationDTO.contexts.push(payload);
    }
    changeablePayload = Object.assign({}, this.destinationDTO);
    this.destinationService
      .updateDestination({
        _id: this.destinationDTO._id,
        ...changeablePayload,
      })
      .then(() => {
        this.loadingService.stop();
      });
  }

  async deleteDescription(description: string): Promise<any> {
    this.onEdit = true;
    this.nzModalService.confirm({
      nzTitle: this.translocoService.translate('destinations.descriptionModal.deleteTitle'),
      nzOkText: this.translocoService.translate('destinations.descriptionModal.yes'),
      nzOnOk: () => {
        this.loadingService.start();
        this.destinationDTO.contexts =
          this.destinationDTO.contexts.filter(
            (d: string) => d !== description
          );
        this.destinationService
          .updateDestination({
            ...this.destinationDTO,
          })
          .then(() => {
            this.loadingService.stop();
          });
      },
      nzCancelText: this.translocoService.translate('destinations.descriptionModal.no'),
      nzOnCancel: () => {
      },
    });
  }

  async addUpdateDestination(e: string): Promise<any> {
    this.loadingService.start();
    const payload = this.destinationDTO;
    switch (e) {
      case 'ADD':
        this.destinationService
          .createDestination({...payload})
          .then(() => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              this.translocoService.translate('destinations.messages.added'),
              'success'
            );
            this.loadingService.stop();
          })
          .catch((error: any) => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              error.error?.message || this.translocoService.translate('destinations.messages.notAdded'),
              'error'
            );
            if (error.error.id){
              this.router.navigate(["/admin/content/destinations/edit/", error.error.id]);
              this.loadingService.stop();
            }
            this.loadingService.stop();
          });
        break;
      case 'EDIT':
        this.onEdit = true;
        this.destinationService
          .updateDestination({
            ...payload
          })
          .then(() => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              this.translocoService.translate('destinations.messages.updated'),
              'success'
            );
            this.loadingService.stop();
          })
          .catch((error: any) => {
            this.actionMessage = new ActionAlert(
              true,
              true,
              error.error?.message || this.translocoService.translate('destinations.messages.notUpdated'),
              'error'
            );
            this.loadingService.stop();
          });
        break;
    }
  }

  onRemove = (item: NzUploadXHRArgs | any): any => {
    return new Promise((resolve) => {
      this.nzModalService.confirm({
        nzTitle: this.translocoService.translate('destinations.imageModal.deleteTitle'),
        nzOkText: this.translocoService.translate('destinations.imageModal.yes'),
        nzOnOk: () => {
          this.loadingService.start();
          this.destinationDTO.images = this.destinationDTO.images.filter(
            (x) => x !== item.url
          );
          this.destinationService.updateDestination(this.destinationDTO).then((res) => {
            this.loadingService.stop();
            resolve(true);
          }).catch(() => {
            this.loadingService.stop();
            resolve(false);
          });
        },
        nzCancelText: this.translocoService.translate('destinations.imageModal.no'),
        nzOnCancel: () => {
          this.ngOnInit();
          resolve(false);
        },
      });
    });
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    const formData = new FormData();
    formData.append('file', item.file);
    return this.uploadService.uploadFile(formData, item);
  }

  handleChange(event: NzUploadChangeParam): any {
    if (!event) {
      return;
    }

    // Keep the file list in sync and use persisted URL when upload is done.
    // Preserve existing entries by uid to avoid re-creating DOM nodes (prevents image flicker).
    const existingByUid = new Map(this.fileList.map(f => [f.uid, f]));

    this.fileList = (event.fileList || []).map((file) => {
      const responseUrl = (file as any)?.response?.url;
      if (file.status === 'done' && responseUrl) {
        return {
          ...(existingByUid.get(file.uid) || file),
          ...file,
          url: responseUrl,
        };
      }
      // For uploading/queued files, merge into the existing entry so the
      // object identity stays stable and *ngFor won't destroy the card.
      const existing = existingByUid.get(file.uid);
      if (existing) {
        return { ...existing, ...file };
      }
      return file;
    });

    // Persist only successfully uploaded image URLs.
    const persistedUrls = this.fileList
      .filter((f) => f.status === 'done' && !!f.url)
      .map((f) => f.url as string);

    this.destinationDTO.images = [...new Set(persistedUrls)];

    // Save only when all uploads are completed (done or error).
    const allDone = this.fileList.every(
      (f) => f.status === 'done' || f.status === 'error'
    );

    const hasSuccessfulUpload = this.fileList.some(
      (f) => f.status === 'done' && !!f.url
    );

    if (allDone && hasSuccessfulUpload) {
      this.destinationService.updateDestination(this.destinationDTO).then(() => {
        this.msg.success(this.translocoService.translate('destinations.messages.updated'));
      }).catch(() => {
        this.msg.error(this.translocoService.translate('destinations.messages.notUpdated'));
      });
    }
  }

  download = async (originalFile: NzUploadFile | any): Promise<any> => {
    this.loadingService.start();
    try {
      const fileName: any = originalFile.url.split('/').pop();
      this.uploadService.downloadFile(fileName).subscribe((blob: Blob) => {
        const file: Blob = new Blob([blob], {
          type: 'application/octet-stream',
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(fileURL);
        this.loadingService.stop();
      });
    } catch (e) {
      this.loadingService.stop();
    }
  }

  async setAsDefaultImage(file: NzUploadFile | any): Promise<void> {
    this.loadingService.start();
    try {
      await this.userService.saveContentImagePreference('destinations', this.destinationDTO._id, file.url);
      this.userPreferredImage = file.url;
      this.msg.success('Default image updated successfully');
    } catch {
      this.msg.error('Failed to update default image');
    } finally {
      this.loadingService.stop();
    }
  }

  search(value: string): void {
    try {
      if (value !== "") {
        this.googlePlacesService.postAutoComplete({
          input: value,
          primaryTypes: ["locality", "natural_feature"]
        }).then(res => {

          this.listOfOption = res?.suggestions || [];
          this.listOfOption.push(this.manualDataInit(value));
        });
      }
    } catch (e) {
    }
  }

  searchNearestLoc(value: string): void {
    try {
      if (value !== "") {
        this.googlePlacesService.postAutoComplete({
          input: value,
          primaryTypes: ["locality", "natural_feature"]
        }).then(res => {

          this.listOfNearestOption = res?.suggestions;
        });
      }
    } catch (e) {
    }
  }

  reset(): void {
    this.searchName = "";
    this.nearestLocation = "";
    this.isDisplayMap = false;
    this.isLocationExist = false;
    this.isDetailsExist = false;
  }

  async selectedResult(data: any): Promise<any> {
    this.actionMessage.display = false;
    try {
      this.loadingService.start();
      if (data.placeId !== "") {
        this.isLocationExist = false;
        this.googlePlaceDetails = await this.googlePlacesService.getPlaceDetails(data.placeId);
        const extractedCountry = getSubstringAfterLastComma(data.structuredFormat.secondaryText.text);
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.isDetailsExist = true;
        const destination: any = {
          tableTitle: data.text.text,
          titles: genTitles,
          city: data.structuredFormat.mainText.text,
          country: extractedCountry,
          location: this.googlePlaceDetails.location,
          apiId: data.placeId,
          entryType: SETTINGS.ENTRY_TYPES.GOOGLE,
          active: true,
        };
        this.destinationDTO = destination;
      }else{
        const genTitles = this.generateTitles(data.structuredFormat.mainText.text, 1);
        this.isLocationExist = true;
        const destination: any = {
          tableTitle: data.text.text,
          titles: genTitles,
          location: "",
          city: data.structuredFormat.mainText.text,
          country: "",
          apiId: data.placeId,
          entryType: SETTINGS.ENTRY_TYPES.MANUAL,
          active: true,
        };
        this.destinationDTO = destination;
      }
      this.loadingService.stop();
    } catch (e) {
      this.loadingService.stop();
    }
  }

  async selectedNearResult(data: any): Promise<void> {
    this.loadingService.start();
    try {
      const result = await this.googlePlacesService.getLocation(data.placeId);
      this.selectedCountry = this.determineCountry(result.formattedAddress);
      this.destinationDTO.country = this.determineCountry(result.formattedAddress);
      this.destinationDTO.location =  result.location;
      this.isDisplayMap = true;
      this.loadingService.stop();
    } catch (e) {
      this.loadingService.stop();
    }
  }

  determineCountry(address: string): string {
    const extractedCountry = getSubstringAfterLastComma(address);
    const findCountry = this.countries.find(country => country.name === extractedCountry);
    return  findCountry ? findCountry.name : "";
  }

  async findBrand(): Promise<any> {
    const user = await this.authService.getLoggedInUser();
    const brand = await this.settingService.findBrand(user.userId);
    this.selectedLanguages = brand?.selectedLanguages || [];
    return this.selectedLanguages;
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  getSelectedLanguagesObjectArray(): any {
    const arr: any = [];
    this.selectedLanguages?.forEach((lang: string) => {
      arr.push(this.languages?.find((l: any) => l.code === lang));
    });
    return arr;
  }

  generateTitles(tempName?: string, toggle?: number): any {
    if (toggle === 1) {
      return this.selectedLanguages.map((languageCode: any) => {
        return {name: tempName, language: languageCode};
      });
    }

    if (toggle === 2) {
      return this.selectedLanguages.map((languageCode: any, index: number) => {
        return {name: this.destinationDTO.titles[index].name, language: languageCode};
      });
    }

  }

  onTitleChange(value: any): void {
    this.title = value;
  }

  async updateTitle(pageType: string): Promise<any> {

    for (let i = 0; i < this.destinationDTO.titles.length; i++) {
      if (this.destinationDTO.titles[i].language === this.language) {
        this.destinationDTO.titles[i].name = this.title;
      }
    }

    await this.addUpdateDestination(pageType === 'new' ? 'ADD' : 'EDIT');
  }

  async updateLocation(pageType: string): Promise<any> {
    await this.addUpdateDestination(pageType === 'new' ? 'ADD' : 'EDIT');
  }

  filterContentByLanguage(lang: string): void {
    this.title = this.destinationDTO.titles
      .filter(obj => obj.language === lang)
      .map(obj => obj.name)
      .join(', ');
    this.contexts = this.destinationDTO.contexts
      .filter(obj => obj.language === lang);
  }

  alertMessageInfo(): void {
    this.actionMessage = new ActionAlert(
      true,
      true,
      this.translocoService.translate('destinations.messages.defaultLanguage'),
      "info"
    );
  }

  private addMissingTitles(city: string, country: string, languages: []): void {
    const nameInEnglish = city + ", " + country;
    if (nameInEnglish) {
      languages.forEach((language: string) => {
        const exists = this.destinationDTO.titles.some(title => title.language === language);
        if (!exists) {
          this.destinationDTO.titles.push({
            name: nameInEnglish,
            language,
          });
        }
      });
    }
  }

  private manualDataInit(name: string): any {
    return {
      placePrediction: {
        text: {text: name},
        placeId: "",
        structuredFormat: {
          mainText: {
            text: name,
          }
        },
        entry: "manual"
      }
    };
  }

  onCoordinatesChanged(coords: { lng: number; lat: number }): void {
    this.destinationDTO.location = { latitude: coords.lat, longitude: coords.lng };
  }

  disableLogic(): boolean {
    if (!this.isLocationExist) {
      return !this.isDetailsExist;
    }else{
      return (!this.isDetailsExist && !this.isLocationExist) ||  this.selectedCountry === "";
    }
  }

  giveOutCoordinates(location: any): any {
    return  location;
  }

  orderByName(list: any[]): any {
    return AppUtils.sortOrderByName(list);
  }

  onChangeCountry(data: any): void {
    this.selectedCountry = data;
    this.destinationDTO.country = this.selectedCountry;
  }
}
